import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
/**
 * Shows a validation message if one exists.
 */

var FieldValidationMessages = /*#__PURE__*/function (_React$Component) {
  _inherits(FieldValidationMessages, _React$Component);

  var _super = _createSuper(FieldValidationMessages);

  function FieldValidationMessages() {
    _classCallCheck(this, FieldValidationMessages);

    return _super.apply(this, arguments);
  }

  _createClass(FieldValidationMessages, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.sanitisedError !== this.props.sanitisedError;
    }
  }, {
    key: "render",
    value: function render() {
      var sanitisedError = this.props.sanitisedError;
      return sanitisedError && sanitisedError.message ? /*#__PURE__*/React.createElement("div", {
        className: "field-message error"
      }, sanitisedError.message) : null;
    }
  }]);

  return FieldValidationMessages;
}(React.Component);

FieldValidationMessages.propTypes = {
  sanitisedError: PropTypes.object
};
export default FieldValidationMessages;